import React, { useState } from "react";
import styles from "./CampaignCreationForm.module.scss";
import ComponentBackButton from "../../../../../common/AdminCommonComponents/Buttons/ComponentBackButton/ComponentBackButton";
import { Row, Col, Form } from "reactstrap";
import FormInput from "../../../../../common/AdminCommonComponents/FormInput/FormInput";
import UploadMedia from "../../../../../common/UploadMedia/UploadMedia";
import DynamicButton from "../../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton";

const CampaignCreationForm = ({ setIsOpen }) => {
    const [formMedia, setFormMedia] = useState([]);

    const [formData, setFormData] = useState({
        name: "",
        category: "",
    });

    const categoriesOptions = [
        { label: "Mega Campaign", value: "megaCampaign" },
        { label: "Daily Sales", value: "dailySales" },
        { label: "Event Sale", value: "eventSale" },
    ];

    const subDivisionOptions = [
        { label: "Main Page", value: "mainPage" },
        { label: "Limited Time Offers", value: "limitedTimeOffers" },
    ];

    const invitationOptions = [
        { label: "Sellers", value: "sellers" },
        { label: "Wholesalers", value: "wholesalers" },
        { label: "Retailers", value: "retailers" },
    ];

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.id]: e.target.value });
    };

    return (
        <div className={styles.mainContainer}>
            <div className={styles.orderDetailWrapper}>
                <ComponentBackButton onClick={() => setIsOpen(false)} />

                <h4 className={styles.mainHeading}>
                    <span>
                        Campaign Creation Form
                    </span>
                </h4>

                <Form>
                    <Row className="g-0">
                        <Col lg={6} className="pe-lg-3">
                            <FormInput
                                label="Name"
                                type="text"
                                placeholder="Campaign name"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                        </Col>
                        <Col lg={6} className="ps-lg-3">
                            <FormInput
                                label="Category"
                                type="select"
                                placeholder="Select category"
                                id="category"
                                name="category"
                                value={formData.category}
                                onChange={handleChange}
                                options={categoriesOptions}
                            />
                        </Col>
                    </Row>
                    <Row className="g-0">
                        <Col lg={6} className="pe-lg-3">
                            <FormInput
                                label="Subdivision"
                                type="select"
                                placeholder="Select subdivision"
                                id="subdivision"
                                name="subdivision"
                                value={formData.subdivision}
                                onChange={handleChange}
                                options={subDivisionOptions}
                            />
                        </Col>
                        <Col lg={6} className="ps-lg-3">
                            <FormInput
                                label="Description"
                                type="text"
                                placeholder="Enter Description"
                                id="description"
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="g-0">
                        <Col lg={6} className="pe-lg-3">
                            <FormInput
                                label="Landing Page URL"
                                type="text"
                                placeholder="Landing page url"
                                id="url"
                                name="url"
                                value={formData.url}
                                onChange={handleChange}
                            />
                        </Col>
                        <Col lg={6} className="ps-lg-3">
                            <FormInput
                                label="Seller Invitation"
                                type="text"
                                placeholder="Select from dropdown"
                                id="invitation"
                                name="invitation"
                                value={formData.invitation}
                                onChange={handleChange}
                                options={invitationOptions}
                            />
                        </Col>
                    </Row>
                    <Row className="g-0">
                        <Col lg={6} className="pe-lg-3">
                            <FormInput
                                label="Start date"
                                type="date"
                                placeholder="Select Start date"
                                id="startDate"
                                name="startDate"
                                value={formData.startDate}
                                onChange={handleChange}
                            />
                        </Col>
                        <Col lg={6} className="ps-lg-3">
                            <FormInput
                                label="End date"
                                type="date"
                                placeholder="Select End date"
                                id="endDate"
                                name="endDate"
                                value={formData.endDate}
                                onChange={handleChange}
                            />
                        </Col>
                    </Row>
                    <Row className="g-0">
                        <Col lg={6} className="pe-lg-3">
                            <FormInput
                                label="Registration Closing date"
                                type="date"
                                placeholder="Select Registration Closing date"
                                id="registrationClosingDate"
                                name="registrationClosingDate"
                                value={formData.registrationClosingDate}
                                onChange={handleChange}
                            />
                        </Col>
                        <Col lg={6} className="ps-lg-3">
                            <UploadMedia
                                pictures={formMedia}
                                setPictures={setFormMedia}
                                maxMedia={3}
                                allowImages={true}
                                allowVideos={true}
                            />
                        </Col>
                    </Row>

                    <div className={styles.submitButton}>
                        <DynamicButton theme="blue">Submit</DynamicButton>
                    </div>

                </Form>
            </div>
        </div>
    );
};

export default CampaignCreationForm;